/* eslint-disable ize/ize */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { createFyRange } from '../resolvers/fy.resolver';
import { createPeriodRange, PeriodData, PeriodParams } from '../resolvers/period.resolver';
import { getChildRoute, TypedActivatedRouteSnapshot } from '../utils/route-utils';
import { slug } from '../utils/slug';

@Injectable({ providedIn: 'root' })
export class RouteService {
  constructor(private router: Router) {}

  getOrganisationRoute(organisationId: string): string {
    const replacedRoute = this.getLinkWithReplacedParameters([]);

    return `${replacedRoute}/organisations/${organisationId}`;
  }

  getOrganisationUsersRoute(organisationId: string): string {
    const replacedRoute = this.getLinkWithReplacedParameters([]);

    return `${replacedRoute}/organisations/${organisationId}/settings/organisation`;
  }

  getRegisterRoute(registerId: string): string {
    const replacedRoute = this.getLinkWithReplacedParameters(['organisations']);

    return `${replacedRoute}/registers/${registerId}`;
  }

  getAssetRoute(assetId: string, assetName: string): string {
    const replacedRoute = this.getLinkWithReplacedParameters([
      'organisations',
      'registers',
      'regimes',
      'periods',
    ]);

    return `${replacedRoute}/assets/${assetId}-${slug(assetName)}`;
  }

  getAssetGroupRoute(assetGroupId: string | number | null | undefined): string {
    const replacedRoute = this.getLinkWithReplacedParameters([
      'organisations',
      'registers',
      'regimes',
      'periods',
    ]);

    return `${replacedRoute}/assetgroups/${assetGroupId}`;
  }

  getAssetsRoute(): string {
    const replacedRoute = this.getLinkWithReplacedParameters([
      'organisations',
      'registers',
      'regimes',
      'periods',
    ]);

    return `${replacedRoute}/assets/`;
  }

  /** Returns a route with current values for route parameters.
   *
   * @param routeParameters - available parameters: organisations, registers, regimes, periods
   */
  getLinkWithReplacedParameters(routeParameters: string[]): string {
    const routeData = getChildRoute(
      this.router.routerState.snapshot.root as TypedActivatedRouteSnapshot<
        Partial<PeriodParams>,
        Partial<PeriodData>
      >,
    ).data;

    let route = '';

    routeParameters.forEach(segment => {
      switch (segment) {
        case 'organisations':
          route += `/${segment}/${routeData.organisation?.activeOrganisation.organisationId || '-'}`;
          break;

        case 'registers':
          route += `/${segment}/${routeData.register?.id || '-'}`;
          break;

        case 'regimes':
          route += `/${segment}/${routeData.regime?.id || '-'}`;
          break;

        case 'periods':
          route += `/${segment}/${createPeriodRange(
            routeData.period?.startDate,
            routeData.period?.endDate,
          )}`;
          break;

        case 'years':
          route += `/${segment}/${createFyRange(
            routeData.period?.startDate,
            routeData.period?.endDate,
            routeData.register,
          )}`;
          break;

        default:
          route += `/${segment}`;
          break;
      }
    });

    return route;
  }
}
